import { render, staticRenderFns } from "./InstanceSliceProfileDetail.vue?vue&type=template&id=506c8f4d&"
import script from "./InstanceSliceProfileDetail.vue?vue&type=script&lang=js&"
export * from "./InstanceSliceProfileDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports